@if (moduleNumber !== 2) {
  @if (onlyAdd) {
    <app-ui-button
      text="{{ 'newRootElement' | translate }}"
      icon="add"
      (click)="openModal(menuTreeButtonActions.Create)"
      class="only-add-button"
      [privilege]="Privileges.MenuCreate"
      [adminPrivilege]="adminPrivilege"
      [disabled]="menuDNDService.isStructureChanged"
      [tooltip]="menuDNDService.isStructureChanged ? 'saveChangesBeforeAddingItem' : ''"
    ></app-ui-button>
    @if (isProductOwner) {
      <app-ui-button
        text="{{ 'copyMenu' | translate }}"
        icon="content_copy"
        (click)="openCopyMenuModal()"
        class="only-add-button"
      ></app-ui-button>
    }
    <ng-container *ngTemplateOutlet="structureActions"></ng-container>
  } @else {
    <div
      class="edit-buttons"
      [class.disabled-edit]="menuDNDService.isStructureChanged"
      [matTooltip]="
        menuDNDService.isStructureChanged ? ('saveChangesBeforeEditingItem' | translate) : ''
      "
    >
      <app-ui-button
        color="primary"
        text="{{ 'newMenuItem' | translate }}"
        buttonType="icon-button"
        icon="add"
        (click)="openModal(menuTreeButtonActions.Create)"
        class="square-menu-button"
        [privilege]="Privileges.MenuCreate"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
      <app-ui-button
        text=""
        buttonType="icon-button"
        icon="remove"
        (click)="openModal(menuTreeButtonActions.Delete)"
        class="square-menu-button"
        [privilege]="Privileges.MenuDelete"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
      <app-ui-button
        text=""
        buttonType="icon-button"
        icon="edit"
        (click)="openModal(menuTreeButtonActions.Update)"
        class="square-menu-button"
        [privilege]="Privileges.MenuUpdate"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
      @if (isProductOwner) {
        <app-ui-button
          text=""
          buttonType="icon-button"
          icon="content_copy"
          (click)="openCopyMenuModal()"
          class="square-menu-button"
        ></app-ui-button>
      }
    </div>
  }
} @else {
  @if (onlyAdd) {
    <app-ui-button
      [text]="'newRootElement' | translate"
      icon="add"
      (click)="openModal(menuTreeButtonActions.Create)"
      [privilege]="[Privileges.ComponentCreate, Privileges.ComponentGroupCreate]"
      [adminPrivilege]="adminPrivilege"
      [disabled]="menuDNDService.isStructureChanged"
      [tooltip]="menuDNDService.isStructureChanged ? 'saveChangesBeforeAddingItem' : ''"
    ></app-ui-button>
    @if (moduleNumber === ModuleNumbers.Maintenance) {
      <app-ui-button
        [text]="'transferComponent' | translate"
        icon="swap_horiz"
        (click)="openTransferComponentModal()"
        [privilege]="Privileges.ComponentTransfer"
      ></app-ui-button>
    }
    @if (isProductOwner) {
      <app-ui-button
        text="{{ 'copyComponents' | translate }}"
        icon="content_copy"
        (click)="openCopyComponentsStructureModal()"
        class="only-add-button"
      ></app-ui-button>
      <app-ui-button
        text="{{ 'showCopyStatus' | translate }}"
        icon="analytics"
        (click)="openCopyStatusModal()"
        class="only-add-button"
      ></app-ui-button>
    }
    <ng-container *ngTemplateOutlet="structureActions"></ng-container>
  } @else {
    <div
      class="edit-buttons"
      [class.disabled-edit]="menuDNDService.isStructureChanged"
      [matTooltip]="
        menuDNDService.isStructureChanged ? ('saveChangesBeforeEditingItem' | translate) : ''
      "
    >
      <app-ui-button
        text=""
        buttonType="icon-button"
        icon="edit"
        (click)="openModal(menuTreeButtonActions.Update)"
        class="square-menu-button"
        [privilege]="[Privileges.ComponentUpdate, Privileges.ComponentGroupUpdate]"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
      <app-ui-button
        text=""
        buttonType="icon-button"
        icon="add"
        (click)="openModal(menuTreeButtonActions.Create)"
        class="square-menu-button"
        [privilege]="[Privileges.ComponentCreate, Privileges.ComponentGroupCreate]"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
      @if (isProductOwner) {
        <app-ui-button
          text=""
          buttonType="icon-button"
          icon="content_copy"
          (click)="openCopyComponentsStructureModal()"
          class="square-menu-button"
        ></app-ui-button>
      }
      @if (moduleNumber === ModuleNumbers.Maintenance && isProductOwner) {
        <app-ui-button
          text=""
          buttonType="icon-button"
          icon="person"
          (click)="openAccessAndResponsibleModal()"
          class="square-menu-button"
        ></app-ui-button>
      }
      <app-ui-button
        text=""
        buttonType="icon-button"
        icon="swap_horiz"
        (click)="openTransferComponentModal()"
        class="square-menu-button"
        [privilege]="Privileges.ComponentTransfer"
        [adminPrivilege]="adminPrivilege"
      ></app-ui-button>
    </div>
  }
}
<ng-template #structureActions>
  @if (menuDNDService.isStructureChanged) {
    <app-ui-button
      color="primary"
      text="{{ 'saveMenuOrder' | translate }}"
      (click)="menuDNDService.saveChanges()"
    ></app-ui-button>
    <app-ui-button
      buttonType="secondary"
      text="{{ 'resetChanges' | translate }}"
      (click)="menuDNDService.cancelChanges()"
    ></app-ui-button>
  }
</ng-template>
